<template>
  <BaseChoice
    title="関連付けるブランドを選択してください"
    resourceType="brand"
    :fields="fields"
    :items="brand.brands"
    :totalItems="totalBrands"
    :isFetching="isFetching"
  />
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import BaseChoice from '@/views/choices/Base.vue';

export default {
  data() {
    return {
      isFetching: false,
    };
  },
  components: {
    BaseChoice,
  },
  mounted() {
    let filterBy = {};

    if (this.prevFormData.corporation) {
      filterBy.corporationId = this.prevFormData.corporation.id;
    }

    this.$logger.debug('Start fetching Brand for Choices');
    this.clearBrands();
    this.isFetching = true;
    this.fetchBrands({ data: { filterBy } }).then(() => {
      this.isFetching = false;
      this.$logger.debug('Done fetching Brand for Choices');
    });
  },
  computed: {
    fields() {
      return [
        {
          key: 'uid',
          label: 'ブランドID',
          sortable: true,
          thAttr: { width: 150 },
        },
        {
          key: 'name',
          label: 'ブランド名',
          sortable: true,
          thAttr: { width: 300 },
        },
        {
          key: 'choiceResource',
          label: '選択',
          sortable: false,
          thAttr: { width: 60 },
        },
      ];
    },
    ...mapState(['brand']),
    ...mapGetters('brand', ['totalBrands']),
    ...mapState('form', ['prevFormData']),
  },
  methods: {
    ...mapActions('brand', ['fetchBrands', 'clearBrands']),
  },
};
</script>
